import { Pickable } from 'app/ts/interfaces/Pickable';
export class ConverterPickable<T> implements Pickable<T> {
  constructor(
    private readonly getter: () => T,
    private readonly converter: (o: T) => Pickable<T>,
  ) {}

  get description() {
    return this.v.description;
  }
  get disabledReason() {
    return this.v.disabledReason;
  }
  get groupName() {
    return this.v.groupName;
  }
  get id() {
    return this.v.id;
  }
  get imageUrl() {
    return this.v.imageUrl;
  }
  get item() {
    return this.v.item;
  }
  get isSelected() {
    return this.v.isSelected;
  }
  get name() {
    return this.v.name;
  }
  get override() {
    return this.v.override;
  }

  get overlay() {
    return this.v.overlay;
  }

  private get v() {
    return this.converter(this.getter());
  }
}
